import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LOGO } from "@/data/site";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-2xl bg-black/70 border-b border-white/10 py-3" : "bg-transparent py-5"
      }`}
    >
      <nav className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between">
        <a href="#home" onClick={(e) => { e.preventDefault(); go("#home"); }} data-testid="navbar-logo" className="flex items-center">
          <img src={LOGO} alt="AS Auto Works" className="h-16 md:h-20 w-auto object-contain" />
        </a>

        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-sm font-medium tracking-widest uppercase text-neutral-300 hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-book-now"
            onClick={() => go("#booking")}
            className="bg-gold text-black font-bold uppercase tracking-widest text-xs px-7 py-3 hover:bg-[#C5A028] transition-colors border border-[#D4AF37]"
          >
            Book Now
          </button>
        </div>

        <button data-testid="mobile-menu-toggle" className="md:hidden text-white" onClick={() => setOpen(!open)}>
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden overflow-hidden bg-black/95 border-t border-white/10"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <button
                  key={l.label}
                  data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                  onClick={() => go(l.href)}
                  className="text-left text-base uppercase tracking-widest text-neutral-200 hover:text-gold"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="mobile-book-now"
                onClick={() => go("#booking")}
                className="bg-gold text-black font-bold uppercase tracking-widest text-sm px-7 py-3"
              >
                Book Now
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
